import React from 'react';

import { ButtonFilled, Image } from 'Components/Base';

const OnlineSolutionButton = (props) => {
  return (
    <ButtonFilled px={{ _: 4, md: 5 }} pb={1} pt={2} color={'white'} height={'40px'} {...props}>
      <Image
        width={'60px'}
        mx={'auto'}
        srcSet={
          '/assets/images/classroom/onlineSolutionButton-1x.png 1x, /assets/images/classroom/onlineSolutionButton-2x.png 2x, /assets/images/classroom/onlineSolutionButton-3x.png 3x,'
        }
        src={'/assets/images/classroom/onlineSolutionButton-3x.png'}
      />
    </ButtonFilled>
  );
};

export default OnlineSolutionButton;
